/** @format */

import { takeLatest } from "redux-saga/effects";
import { TActionType } from "../declarations/actionTypes";
import { sagaAdministratorList } from "../sagas/sagasAdministrator";

export function* watcherAdministrator(): unknown {
  yield takeLatest(TActionType.administratorListRequest, sagaAdministratorList);
}
